import React from 'react'
import {
  COLUMN_TYPES,
  Icon,
  reducers,
  SEARCH_TYPES,
  DATA_TYPES,
  LOOKUP_TYPES,
  constants,
} from '@adc/ui-morpheus'
import { MORPHEUS_LOGS } from '../../constants/tableTypes'
import { serviceType, status } from '../../constants/optionLists'

const {
  actionCellActionTypes: { ACTION_CELL_ACTION_TYPES },
} = constants
const defaultColPropsWithWidth300 = {
  width: 300,
  isResizable: true,
  isReorderable: true,
  isVisible: false,
}
const defaultColPropsWithWidth150 = {
  width: 150,
  isResizable: true,
  isReorderable: true,
  isVisible: false,
}

export const tableConfig = {
  config: {
    entityKey: MORPHEUS_LOGS,
    primaryKeyField: 'id',
  },
  fieldDefinitions: [
    {
      name: 'Transaction ID',
      apiRef: 'transaction_id',
      columnDefinition: {
        type: COLUMN_TYPES.TEXT,
        partialMatch: true,
        colProps: {
          ...defaultColPropsWithWidth300,
          isVisible: true,
          searchable: true,
        },
      },
    },
    {
      name: 'Service',
      apiRef: 'action',
      searchType: SEARCH_TYPES.SUGGEST_SYNC,
      options: serviceType,
      formatOptions: {
        titleCase: true,
      },
      columnDefinition: {
        type: COLUMN_TYPES.TEXT,
        colProps: {
          ...defaultColPropsWithWidth150,
          isVisible: true,
          sort: 0,
          searchable: true,
        },
      },
    },
    {
      name: 'Status',
      apiRef: 'status',
      searchType: SEARCH_TYPES.SUGGEST_SYNC,
      options: status,
      formatOptions: {
        titleCase: true,
      },
      columnDefinition: {
        type: COLUMN_TYPES.STATUS,
        positiveValue: 'Success',
        negativeValue: 'Failure',
        colProps: {
          ...defaultColPropsWithWidth150,
          sort: 0,
          isVisible: true,
          searchable: true,
        },
      },
    },
    {
      name: 'Response',
      apiRef: 'reference_message',
      columnDefinition: {
        type: COLUMN_TYPES.TEXT,
        colProps: { ...defaultColPropsWithWidth300, isVisible: true },
      },
    },
    {
      name: 'Transaction Date',
      dataType: DATA_TYPES.DATETIME_AS_LOCAL,
      searchType: SEARCH_TYPES.DATE,
      apiRef: 'action_date',
      columnDefinition: {
        type: COLUMN_TYPES.DATE,
        colProps: {
          ...defaultColPropsWithWidth150,
          isVisible: true,
          sort: 1,
          searchable: true,
        },
      },
    },
    {
      name: 'User',
      apiRef: 'created_by',
      searchType: SEARCH_TYPES.SUGGEST_ASYNC_ONE_TIME,
      dataType: DATA_TYPES.NUMBER,
      foreignKey: LOOKUP_TYPES.USER,
      columnDefinition: {
        type: COLUMN_TYPES.TEXT,
        colProps: {
          ...defaultColPropsWithWidth150,
          isVisible: true,
          searchable: true,
        },
      },
    },
    {
      name: 'Internal IDs',
      apiRef: 'internal_reference_ids.internal_id',
      columnDefinition: {
        type: COLUMN_TYPES.TEXT,
        partialMatch: true,
        colProps: {
          ...defaultColPropsWithWidth300,
          isVisible: true,
          searchable: true,
        },
      },
    },
    {
      name: 'External IDs',
      apiRef: 'external_reference_ids.external_id',
      columnDefinition: {
        type: COLUMN_TYPES.TEXT,
        partialMatch: true,
        colProps: {
          ...defaultColPropsWithWidth300,
          isVisible: true,
          searchable: true,
        },
      },
    },
    {
      name: '',
      apiRef: '__actions__', // not api val
      isUiOnly: true,
      columnDefinition: {
        type: COLUMN_TYPES.ACTION,
        actions: [ACTION_CELL_ACTION_TYPES.DISPLAY_DETAILS],
        colProps: { width: 50, fixedRight: true, align: 'center' },
      },
    },
  ],
  filterClauses: [],
  sortBy: [
    {
      field: 'action_date',
      order: 'asc',
    },
  ],
}

const columnAction =
  actionCellActionType =>
  (actionIndex, rowIndex, primaryId, data, onRowAction) =>
    (
      <Icon
        color='info'
        size='large'
        style={{ marginTop: -3, cursor: 'pointer' }}
        name='zoom'
        key={actionIndex}
        title='View Details'
        data-elm-id={`action_edit_${rowIndex}`}
        onClick={() => onRowAction(actionCellActionType, rowIndex, primaryId)}
      />
    )

export const columnSelector = state =>
  state.fieldDefinitions
    .filter(field => field.columnDefinition)
    .map(col => {
      const column = {
        ...col.columnDefinition,
        ...{ field: col.apiRef, title: col.name },
      }
      if (column.actions) column.actions = column.actions.map(columnAction)
      if (col.dataType) column.dataType = col.dataType
      if (col.searchType) column.searchType = col.searchType
      if (col.options) column.options = col.options
      if (col.formatOptions) column.formatOptions = col.formatOptions
      return column
    })

export const getFilterClauses = state => state.filterClauses

export default reducers.dataTable.dataTable(MORPHEUS_LOGS, tableConfig)
